import { COMMON_EVENT_NAMES } from "../../constants";

export const EVENT_NAME = {
  NEXT: "Program Race Selected",
  BACK: "Program Race Selected",
  OPEN: "Opened",
  NAVIGATED: COMMON_EVENT_NAMES.NAVIGATED,
  SCROLLED: "Scrolled Bet Types",
  SELECTED_BET: "Program Bet Type Selected",
  SELECT: "Select",
  SELECTION_ADD: "Add To Betslip",
  SELECTION_REMOVE: "Selection Removed",
  SELECTED_RACE_NUM: "Program Race Selected"
};

export const LABELS = {
  PROGRAM_HANDICAPPING_TOOLTIP: "Program Handicapping Tooltip",
  PROGRAM_RACE: "Program Race Selector",
  PROMOS: "Promos"
};
